export default __webpack_public_path__ + "static/media/XEMP-17.890dd49c.jpg";